import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Adds a CustomLineItem to the cart.`}</p>
      <p parentName="section">{`If the cart already contains a `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#customlineitem"
        }}>{`CustomLineItem`}</a>{` with the same slug, name, money, tax category, state, and custom fields, then only the quantity of the existing custom line item is increased.
If `}<inlineCode parentName="p">{`shippingDetails`}</inlineCode>{` are set, they will be merged, meaning all addresses will be present afterwards and, for address keys present in both shipping details, the quantity will be summed up.
If the cart already contains a custom line item with the same slug that is otherwise not identical, an `}<a parentName="p" {...{
          "href": "/api/../api/errors#400-bad-request-1"
        }}>{`InvalidOperation`}</a>{` error is returned.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addCustomLineItem"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#localizedstring"
          }}>{`LocalizedString`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`quantity`}</inlineCode>{` - Number - Optional - Defaults to `}<inlineCode parentName="li">{`1`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`money`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#money"
          }}>{`Money`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`slug`}</inlineCode>{` - String`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`taxCategory`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/taxCategories#taxcategory"
          }}>{`TaxCategory`}</a>{` - Required only for `}<inlineCode parentName="li">{`Platform`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#taxmode"
          }}>{`TaxMode`}</a><br parentName="li"></br>
          {`The given tax category will be used to select a tax rate when a cart has the tax mode `}<inlineCode parentName="li">{`Platform`}</inlineCode>{`.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTaxRate`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externaltaxratedraft"
          }}>{`ExternalTaxRateDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`An external tax rate can be set if the cart has the `}<inlineCode parentName="li">{`External`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#taxmode"
          }}>{`TaxMode`}</a>{`.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`custom`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields#customfieldsdraft"
          }}>{`CustomFieldsDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`The custom fields.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`shippingDetails`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#itemshippingdetailsdraft"
          }}>{`ItemShippingDetailsDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`Container for custom line item specific address(es).`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`priceMode`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/projects/carts#customlineitempricemode"
          }}>{`CustomLineItemPriceMode`}</a>{` - Optional`}<br parentName="li"></br>
          {`Specifies whether Cart Discounts with a matching `}<a parentName="li" {...{
            "href": "/api/projects/cartDiscounts#cartdiscountcustomlineitemstarget"
          }}>{`CartDiscountCustomLineItemsTarget`}</a>{` are applied to the custom line item: `}<inlineCode parentName="li">{`Standard`}</inlineCode>{` = yes, `}<inlineCode parentName="li">{`External`}</inlineCode>{` = no.`}</li>
      </ul>
      <p parentName="section">{`Specific Error Codes:`}</p>
      <ul parentName="section">
        <li parentName="ul"><a parentName="li" {...{
            "href": "/api/../api/errors#orders-400-missing-tax-rate-for-country"
          }}>{`MissingTaxRateForCountry`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      